import store from '@/apps/open/store'
import { RSA_TAIL_KEY } from '@/apps/open/constants'
const CryptoJS = require('crypto-js')
const RsaCryptoJS = require('jsencrypt').JSEncrypt

function getRandomStr (len: number) {
  const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz'
  let res_random_str = ''
  for (let i = 0; i < len; i++) {
    res_random_str += str[Math.round(Math.random() * (str.length - 1))]
  }
  return res_random_str
}

const SECRET_RSA_PUB_KEY = store.getters['RSA_HEAD_KEY'] + process.env.VUE_APP_RSA_MIDDLE_KEY + RSA_TAIL_KEY
const RSA_PUB_KEY = atob(SECRET_RSA_PUB_KEY)

const AES_INFO = {
  private_key: getRandomStr(32),
  iv: getRandomStr(16)
}
const rsaCryptoJS = new RsaCryptoJS()
rsaCryptoJS.setPublicKey(RSA_PUB_KEY)

// AES 密钥
const AES_KEY = CryptoJS.enc.Utf8.parse(AES_INFO.private_key)
// AES 配置
const AES_CONF = {
  iv: CryptoJS.enc.Utf8.parse(AES_INFO.iv)
}

export const CRYPT_AES_KEY = rsaCryptoJS.encrypt(JSON.stringify(AES_INFO))

// 根据config.params获取query参数
export function getQueryString (obj: any) {
  let res: string = ''
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    Object.keys(obj).forEach((key: string) => {
      res += `${key}=${obj[key]}&`
    })
    return res.substring(0, res.length - 1)
  } else {
    return ''
  }
}

// AES 加密
export function encryptAES (data: any) {
  if (Object.prototype.toString.call(data) !== '[object String]') {
    data = JSON.stringify(data)
  }
  return CryptoJS.AES.encrypt(data, AES_KEY, AES_CONF).toString()
}

// AES 解密
export function decryptAES (data: any) {
  return JSON.parse(CryptoJS.AES.decrypt(data, AES_KEY, AES_CONF).toString(CryptoJS.enc.Utf8))
}
